module.exports = __webpack_public_path__ + "img/img33.bb9c1e1c.svg";